export const SEARCH_USER_DIALOG = 'SEARCH_USER_DIALOG';
export const SEARCH_COMPANY_DIALOG = 'SEARCH_COMPANY_DIALOG';
export const CREATE_COMPANY_DIALOG = 'CREATE_COMPANY_DIALOG';
export const CREATE_METRIC_DIALOG = 'CREATE_METRIC_DIALOG';
export const CREATE_GRAPH_DIALOG = 'CREATE_GRAPH_DIALOG';
export const CREATE_STORE_DIALOG = 'CREATE_STORE_DIALOG';
export const ADD_USER_STORE_DIALOG = 'ADD_USER_STORE_DIALOG';
export const USER_DIALOG = 'USER_DIALOG';
export const ME_USER_DIALOG = 'ME_USER_DIALOG';
export const CREATE_USER_DIALOG = 'CREATE_USER_DIALOG';
export const ME_PASSWORD_DIALOG = 'ME_PASSWORD_DIALOG';
export const UPLOAD_DIALOG = 'UPLOAD_DIALOG';